

import { useState, useCallback } from 'react';
import Cookies from 'js-cookie';

export const useCookie = (cookieName: string) => {
  const [value, setValue] = useState<string | null>(() => {
    return Cookies.get(cookieName) || null;
  });

  const updateCookie = useCallback((newValue: string, options?: any) => {
    Cookies.set(cookieName, newValue, options);
    setValue(newValue);
  }, [cookieName]);

  const deleteCookie = useCallback(() => {
    Cookies.remove(cookieName);
    setValue(null);
  }, [cookieName]);

  return {
    value,
    setValue: updateCookie,
    remove: deleteCookie
  };
};
export const getToken = (cookieName: string) => {
 return Cookies.get(cookieName) || null
};

export function removeToken(cookieName: string,) {
  Cookies.remove(cookieName);
}
